var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-item-group", [
        _c(
          "div",
          { staticStyle: { "min-width": "275px", height: "70px" } },
          [
            _c(
              "v-layout",
              { staticClass: "profile-options-wrapper" },
              _vm._l(_vm.profilesMapping, function(profile) {
                return _c(
                  "v-item",
                  { key: profile.slug },
                  [
                    _c(
                      "v-flex",
                      { staticStyle: { "min-width": "45px" } },
                      [
                        _c("profile-selector-option", {
                          attrs: {
                            profile: profile,
                            "active-profile-slug": _vm.activeProfileSlug,
                            "active-vehicle-type": _vm.activeVehicleType
                          },
                          on: { profileSelected: _vm.profileSelected }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.activeVehicleType
        ? _c(
            "div",
            [
              _c(
                "v-chip",
                {
                  attrs: {
                    outline: "",
                    small: "",
                    disabled: "",
                    color: "primary"
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("global.profile")) +
                      ": " +
                      _vm._s(
                        _vm.$t(
                          "orsMapFilters.profiles." + _vm.activeVehicleType
                        )
                      ) +
                      "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _vm.activeProfileSlug
        ? _c(
            "div",
            [
              _c(
                "v-chip",
                {
                  attrs: {
                    outline: "",
                    small: "",
                    disabled: "",
                    color: "primary"
                  }
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.$t("global.profile")) + ": "),
                  _vm.$store.getters.mapSettings.skipAllSegments
                    ? _c("span", [_vm._v(_vm._s(_vm.$t("global.rawRouting")))])
                    : _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "orsMapFilters.profiles." + _vm.activeProfileSlug
                            )
                          )
                        )
                      ])
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f321721", { render: render, staticRenderFns: staticRenderFns })
  }
}